import React, { PureComponent } from 'react';
import TranslationsScope from '@client/components/shared/translation/TranslationsScope';
import { track } from '@client/helpers';
import DoiSuccessContent from './doiSuccessContent/DoiSuccessContent';

export class DoiSuccess extends PureComponent {
    render() {
        return (
            <TranslationsScope path="doiSuccessOverlay">
                <DoiSuccessContent closeOverlay={this.props.closeOverlay} />
            </TranslationsScope>
        );
    }

    componentDidMount() {
        track('onboarding.success_action', {
            success_description: 'sendDoiSuccess',
        });
    }
}

export default DoiSuccess;
